<template>
  <!--审定验收管理办法-->
  <div class="article-detail certificate">
    <!-- 头部导航组件 -->
    <header-cmp></header-cmp>
    <menu-cmp></menu-cmp>
    <section>
      <div class="content page-content">
        <breadcrumb :list="[{ title: '详情' }]" />
        <div class="article-main">
          <div class="article-main-left">
            <img
              v-if="article.bannerImg"
              :src="article.bannerImg"
              class="article-img"
            />
            <div class="article-title">{{ article.name || article.title }}</div>
            <div class="article-time-author">
              {{ article.author }}
              <span class="article-time"
                >{{
                  article.createdate
                    ? moment(article.createdate).format("YYYY-MM-DD")
                    : ""
                }}
              </span>
            </div>
            <div class="article-content" ref="articleContentRef"  v-html="article.content || article.bookIntroduction">
            </div> 
            <!--<iframe
              @load="frm"
              id="article-box"
              frameborder="0"
              name="showhere"
              scrolling="auto"
              src=""
              :height="contentHeight"
              :width="contentWidth"
            ></iframe>-->
            <!-- <template v-if="!isProduct">
              <a
                class="article-download"
                :href="attachment.url"
                :download="attachment.filename"
                v-for="(attachment, index) in article.attachments"
                :key="'attachment' + index"
                >{{ attachment.filename }}</a
              >
            </template> -->
          </div>
          <div class="article-main-right">
            <template v-if="related.list.length">
              <div class="article-main-right-title">{{ related.title }}</div>
              <ul class="right-list">
                <li
                  v-for="item in related.list"
                  :key="item.id"
                  class="right-list-item"
                  @click="gotoArticle(item.id)"
                >
                  · {{ item.title || item.name }}
                </li>
              </ul>

              <div
                class="article-main-right-title"
                v-if="article.attachments.length > 0"
              >
                附件
              </div>
              <ul class="right-list">
                <li
                  v-for="item in attachments"
                  :key="item.id"
                  class="right-list-item"
                  @click="gotourl(item.url)"
                >
                  · {{ item.title || item.filename }}
                </li>
              </ul>
            </template>
            <!--
                <div class="article-main-right-btn" @click="gotoSth()">{{ isProduct ? '去购买' : '下一篇' }}</div>
                -->
            <template v-if="isProduct && article.url">
              <a
                :href="article.url"
                class="article-main-right-btn"
                target="_blank"
                >{{ "去购买" }}</a
              >
              <div class="buy-panel">
                <div class="buy-tip">
                  *购买单位和个人需扫描下方问卷星二维码，填写购买信息。
                </div>
                <vue-qr
                  class="buy-qr"
                  :logoSrc="article.coverimg"
                  :text="article.url"
                  :size="200"
                ></vue-qr>
                <!--<img class="buy-qr" src="@/assets/image/service/qr.png" />-->
              </div>
            </template>
          </div>
        </div>
      </div>
    </section>
    <footer-cmp></footer-cmp>
  </div>
</template>

<script>
import headerCmp from "@/components/common/header.vue";
import menuCmp from "@/components/common/navMenu.vue";
import footerCmp from "@/components/common/footer.vue";
import { serviceMenu } from "@/utils/const.js";
import Breadcrumb from "./Breadcrumb.vue";
import moment from "moment";
import book from "@/api/book";
import biz from "@/api/biz";
import { getNewsList } from "@/api/news.js";
import vueQr from "vue-qr";
import "@/assets/style/detail-reset.scss";

export default {
  data() {
    return {
      title: "",
      pageId: this.$route.query.id,
      pageType: this.$route.query.type,
      artId: this.$route.query.artId,
      serviceMenu,
      article: {},
        contentWidth:800,
      contentHeight: 2000,
      attachments: [],
      related: { title: "", list: [] },
      isProduct: false, //书籍 奖座及证书
    };
  },
  components: {
    headerCmp,
    menuCmp,
    footerCmp,
    Breadcrumb,
    vueQr,
  },
  methods: {
    moment,
    /*****左侧详情&&右侧列表 */
    getContent() {
      const pageId = this.pageId;
      const id = this.artId;
      this.isProduct = pageId > 7;

      if (this.isProduct) {
        //书籍 奖座及证书
        book.fetch({ id: this.artId }).then((res) => {
          let data = res.data;
          if (data.url) {
            data.url.indexOf("http") == -1 && (data.url = "http://" + data.url);
          }
          this.article = data;
        //   this.frm();
          this.attachments = data.attachments;
        });
        book
          .list({
            pageSize: 5,
            pageIndex: 1,
            type: pageId - 7,
          })
          .then((res) => {
            let data = res.data.list;
            this.related = {
              title: this.serviceMenu[this.pageId].name,
              list: data.filter((i) => i.id != id),
            };
          });
      } else {
        biz
          .articleDetail({
            id: this.artId,
          })
          .then((res) => {
            console.log("res.data", res.data);
            this.attachments = res.data.attachments;
            this.article = res.data;
            //  this.frm();
          });
        if (this.pageType != "case") {
          getNewsList({
            categorys: this.pageType == 0 ? "标准" : "办法",
            pageIndex: 1,
            pageSize: 5,
          }).then((res) => {
            this.related = {
              title: "相关标准及办法",
              list: res.data.list.filter((i) => i.id != id),
            };
          });
        } else {
          //案例的详情，右侧请求相关案例
          biz
            .fetch({
              name: serviceMenu[pageId].name,
            })
            .then((res) => {
              if (res.data) {
                console.log("res.data", res.data);
               
                this.related = {
                  title: "相关案例",
                  list: res.data.relatedCases.filter((i) => i.id != id),
                };
              } else {
                this.related.list = [];
              }
            });
        }
      }
    },
    gotoArticle(id) {
      this.$router.push(
        this.$route.fullPath.replace(/artId=(\d)+/, "artId=" + id)
      );
    },
    gotoSth() {
      if (this.isProduct) {
      } else {
        this.$router.push(
          "/service/article-detail?artId=" + this.related.list[0].id
        );
      }
    },

    gotourl(url) {
      window.open(url);
    },
    // frm() {
    //   let iframeBox = document.getElementById("article-box");
    //   let _obj = iframeBox.contentWindow || iframeBox.contentDocument;
    //   let doc = _obj.document;
    //   //iframeBox.height = iframeWin.document.documentElement.scrollHeight || iframeWin.document.body.scrollHeight;
    //   doc.body.innerHTML = this.article.content ||"";
    //   _obj.height = doc.body.scrollHeight;
    //   this.contentHeight = doc.body.scrollHeight;
    //   this.contentWidth = doc.body.scrollWidth;
     
    // },
  },
  watch: {
    $route() {
      this.pageId = this.$route.query.id;
      this.pageType = this.$route.query.type;
      this.artId = this.$route.query.artId;
      this.getContent();
    },
  },
  mounted() {
    this.getContent();
  },
};
</script>
<style lang="scss" scoped>
.article-detail {
  .content {
    .article-main {
      margin-top: 40px;
      display: flex;
      justify-content: space-between;
      &-left {
        width: 64.92%;
      }
      .article-img {
        width: 100%;
        border-radius: 8px;
        margin-bottom: 32px;
      }
      .article-title {
        font-size: 34px;
        font-weight: 500;
        color: #333333;
        line-height: 46px;
      }
      .article-time-author {
        display: flex;
        justify-content: space-between;
        margin: 20px 0;
        color: #333;
        line-height: 20px;
        .article-time {
          color: #666;
        }
      }
    //   .article-content {
        // color: #454545;
        // font-size: 16px;
        // line-height: 24px;
        // ::v-deep {
        //   p {
        //     color: #454545;
        //     font-size: 16px;
        //     line-height: 24px;
        //     text-indent: 2em;
        //     word-break: break-all;
        //     white-space: normal;
        //   }
        //   strong {
        //     font-size: 18px;
        //     font-weight: 500;
        //     line-height: 32px;
        //   }
        //   img {
        //     max-width: 100%;
        //   }
        // }
      }
      .article-download {
        margin-top: 40px;
        display: block;
        font-size: 18px;

        font-weight: 500;
        color: #da5351;
        line-height: 25px;
        cursor: pointer;
      }
      .article-book-info {
        line-height: 24px;
        color: #454545;
        &-title {
          font-size: 18px;

          font-weight: 500;
          margin-bottom: 12px;
          margin-top: 32px;
        }
        &-c {
          font-size: 16px;
        }
        .buy-qr-b {
          height: 288px;
          max-width: 100%;
        }
      }
    }
    .article-main-right {
      font-weight: 500;
      width: 31.67%;
      &-title {
        font-size: 24px;
        color: #da5351;
        line-height: 33px;
        margin-bottom: 18px;
      }
      .right-list {
        font-size: 16px;
        color: #333333;
        line-height: 26px;
        &-item {
          cursor: pointer;
          margin-bottom: 16px;
        }
      }
      &-btn {
        display: block;
        text-decoration: none;
        font-size: 18px;
        color: #ffffff;
        line-height: 40px;
        width: 120px;
        height: 40px;
        background: linear-gradient(144deg, #ef8b89 0%, #da5351 100%);
        border-radius: 30px;
        text-align: center;
        margin: 0 auto;
        margin-top: 16px;
        cursor: pointer;
      }
      .buy-panel {
        width: 100%;
        text-align: center;
        margin-top: 20px;
        .buy-tip {
          color: #da5351;
          line-height: 20px;
          margin-bottom: 20px;
        }
      }
    }
  }


@media screen and (max-width: 960px) {
  .article-detail {
    .header {
      margin-bottom: 0.16rem;
    }
    .content {
      .article-main {
        padding-top: 0.2rem;
        flex-wrap: wrap;
        &-left,
        &-right {
          width: 100%;
        }

        .article-title {
          font-size: 0.24rem;
          line-height: 0.3rem;
        }
        .article-time-author {
          font-size: 0.12rem;
          line-height: 0.14rem;
          .article-time {
            float: right;
          }
        }
        // .article-content {
        //   color: #454545;
        //   font-size: 0.16rem;
        //   line-height: 0.24rem;
        //   ::v-deep {
        //     p {
        //       font-size: 0.16rem;
        //       line-height: 1.5;
        //     }
        //     strong {
        //       font-size: 0.18rem;
        //       line-height: 0.32rem;
        //     }
        //   }
        // }
        .article-download {
          font-size: 0.16rem;
          text-decoration: underline;
        }
        .article-book-info .buy-qr-b {
          height: auto;
        }
        .article-main-right {
          margin-top: 0.24rem;
          &-title {
            font-size: 0.18rem;
            color: #333333;
            line-height: 0.24rem;
            padding-bottom: 0.12rem;
            border-bottom: 1px solid #f1f1f1;
          }
          .right-list {
            font-size: 0.14rem;
            font-weight: 400;
            color: #454545;
            line-height: 0.2rem;
          }
          &-btn {
            width: 0.96rem;
            height: 0.3rem;
            border-radius: 0.15rem;
            border: 1px solid #cc3b3f;
            font-size: 0.14rem;
            color: #cc3b3f;
            line-height: 0.3rem;
            background: transparent;
          }
          .buy-panel {
            margin-top: 0.2rem;
            .buy-tip {
              font-size: 0.12rem;
              line-height: 0.2rem;
              margin-bottom: 0.2rem;
            }
          }
        }
      }
    }
  }
}
</style>